<script lang="ts">
	import { RelatedTalksMobile } from './RelatedTalksMobile';
	import { TalkSpeakersAccordions } from './TalkSpeakersAccordions';
	import { Config } from '#lib/constants/config.js';
	import { GlobalRoutes } from '#lib/features/navigation/constants/global-routes.js';
	import { TalksRoutes } from '#lib/websites/talks/constants/routes.js';
	import { RelatedTalks } from '#lib/websites/talks/pages/TalkPage/RelatedTalks/index.js';
	import { TalkDetails } from '#lib/websites/talks/pages/TalkPage/TalkDetails/index.js';
	import { page } from '$app/state';
	import { Breadcrumbs } from '$global/components/Breadcrumbs';
	import { Container } from '$global/components/Container';
	import { getImageUrl } from '$global/utils/getImageUrl';
	import { getPageData } from '$global/utils/getPageData/getPageData';
	import type { TalksPDPPageData } from '$routes/talks/[slug]/types';

	const dataCy = 'talk-page';
	let data = $derived(getPageData<TalksPDPPageData>(page.data));
	let talk = $derived(data.talk);
	let artistSlugs = $derived(data.artistSlugs);

	let crumbs = $derived([
		{
			label: 'Home',
			href: GlobalRoutes.TalksHome,
		},
		{
			label: 'Talks',
			href: TalksRoutes.Gallery,
		},
		{
			label: talk.title,
		},
	]);

	let relatedVideos = $derived(
		(data.relatedTalks || []).map((talk) => {
			return {
				title: `${talk?.related_HENI_Talks_Talks_id?.title}`,
				image: getImageUrl(
					talk?.related_HENI_Talks_Talks_id?.image_16_9?.filename_disk
				),
				description: `${talk?.related_HENI_Talks_Talks_id?.short_description}`,
				duration: `${talk?.related_HENI_Talks_Talks_id?.video_duration}`,
				href: `${GlobalRoutes.TalksHome}/${talk?.related_HENI_Talks_Talks_id?.slug}`,
				id: `${talk?.related_HENI_Talks_Talks_id?.id}`,
			};
		})
	);
</script>

<Breadcrumbs {dataCy} {crumbs} />
<Container {dataCy} class="mb-[8.75rem] lg:flex lg:space-x-6">
	<div class="lg:w-2/3">
		<TalkDetails
			type="talk"
			speakers={(data.speakers || []).map((speaker) => ({
				name: `${speaker?.HENI_Talks_Speakers_id?.name}`,
				href: `${TalksRoutes.Gallery}/?1=${encodeURIComponent(
					speaker?.HENI_Talks_Speakers_id?.name as string
				)}&1_type=3`,
			}))}
			images={[]}
			shareUrl={`${Config.Domain}${GlobalRoutes.TalksHome}/${talk.slug}`}
			timePeriod={talk.time_period?.name}
			filmDetails={talk.film_details}
			youtubeUrl={talk.youtube_url}
			furtherMedia={talk.further_media}
			credits={talk.credits}
			transcript={talk.transcript}
			title={`${talk?.title}`}
			detailsLabel="Film Details"
			{dataCy}
		/>
		<TalkSpeakersAccordions
			podcastOpenpanelPrefix="TALKS/TALK_PAGE"
			{artistSlugs}
			{dataCy}
		/>
	</div>
	<div class="lg:w-1/3">
		<RelatedTalks type="talk" {relatedVideos} {dataCy} />
		<RelatedTalksMobile {relatedVideos} {dataCy} />
	</div>
</Container>
